import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-grid-system';
import { prettyMatchUrl, getFootballTeamImagePath } from '../../common/rcs_gaz_mc_core_FE';
import PreferredStar from '../PreferredStar';
import TeamLabel from '../TeamLabel';
import Timing from '../TimeResults/Timing';
import Result from '../TimeResults/Result';
import IconFont from '../../components/shared/IconFont';
import MatchRowScorers from '../../components/MatchRowScorers';
import MatchRowIcon from '../../components/MatchRowIcon';
//import BetBar from '../../components/BetBar';
import LocalStorageUtility from '../../common/localStorageUtility/localStorageUtility';
import { MatchRowWrapper, MatchStatsWrapper, MatchForfait} from './styles';
//import * as status from '../../constants';
import ConfigManager from '../../common/configManager/configManager';


const MatchRow = ({
  matchRow, showRowScorer, actions, dictionary, isMobile, date, sportId, isHighlight, competitionId,
}) => {
  const handleFavourites = () => {
    if (!showRowScorer) {
      if (!LocalStorageUtility.isPreferred(matchRow.get('matchId'))) {
        actions.showTooltip();
        setTimeout(() => {
          actions.hideTooltip();
        }, 2500);
      }
      actions.favouriteGame(sportId, matchRow.get('matchId'));
      actions.setFavouritesOnCompetition(matchRow.get('matchId'));
    } else {
      actions.removefavouriteGame(sportId, matchRow.get('matchId'), date);
    }
  };

  const awayResPen = (matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'score']) : 0;
  const homeResPen = (matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score'])) ?
    matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'score']) : 0;

  const isHomeWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) + Number(homeResPen))
    > (Number(matchRow.getIn(['awayTeam', 'score']))) + Number(awayResPen) && matchRow.get('status') !== 'LIVE';
  const isAwayWinner = () => (Number(matchRow.getIn(['homeTeam', 'score'])) + Number(homeResPen))
    < (Number(matchRow.getIn(['awayTeam', 'score'])) + Number(awayResPen)) && matchRow.get('status') !== 'LIVE';
  const isLive = () => matchRow.get('status') === 'LIVE';
  const imagesURL = ConfigManager.getFootballTeams('min');

  /*let prettyHomeTeam = matchRow.getIn(['homeTeam', 'teamName']);
  prettyHomeTeam = prettyHomeTeam.toLowerCase().replace('.', '').split(' ').join('_');
  let prettyAwayTeam = matchRow.getIn(['awayTeam', 'teamName']);
  prettyAwayTeam = prettyAwayTeam.toLowerCase().replace('.', '').split(' ').join('_');*/

  const classLink = () => {
    if (process.env.REACT_APP_SITE === 'fcinter' || process.env.REACT_APP_SITE === 'calcionapoli1926' || process.env.REACT_APP_SITE === 'forzaroma') {
      const compId = String(competitionId);
      if (compId !== '21' && compId !== '105' && compId !== '259' && compId !== '5' && compId !== '6' && compId !== '24' && compId !== '22' && compId !== '8' && compId !== '23' ) {
        return 'no-event';
      }
      return '';
    }
    // let returnedClass = '';
    // if (String(sportId) === '1' && String(competitionId) === '3') {
    //   returnedClass = 'no-event';
    // }
    // return returnedClass;
    return '';
  };

  const getTeamsName = () => {
    let teamsName = {};
    teamsName.homeTeamId = matchRow.getIn(['homeTeam', 'teamId']);
    teamsName.homeTeam = matchRow.getIn(['homeTeam', 'teamName']);
    teamsName.awayTeamId = matchRow.getIn(['awayTeam', 'teamId']);
    teamsName.awayTeam = matchRow.getIn(['awayTeam', 'teamName']);
    return teamsName;
  };

  const getRoundTripLoser = () => {
    const competitionId = matchRow.get('competitionId');
    const competitionRoundId = matchRow.get('competitionRoundId');
    const isSpecialCup =
      competitionId === '5' ||
      competitionId === '6' ||
      (competitionRoundId === 'Semi-Finals' && competitionId === '259') ||
      competitionId === '1125';
    if (matchRow.get('firstLegResult') && isSpecialCup) {
      let winnerId =
      matchRow.get('secondLegResult') && matchRow.getIn(['secondLegResult', 'winnerId'])
      let loser =
        winnerId === getTeamsName().homeTeamId ? 'away' : 'home';
      return winnerId ? loser : null;
    } else {
      return null;
    }
  };

  return (
    <MatchRowWrapper
      isHighlight={isHighlight}
      className={classLink()}
      href={prettyMatchUrl(matchRow.getIn(['homeTeam', 'teamName']), matchRow.getIn(['awayTeam', 'teamName']), matchRow.get('matchId'), sportId, competitionId, process.env.REACT_APP_SITE)}
      hideMatch={matchRow.get('matchId') === '980149'}
    >
      <Row style={{
        width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'center',
      }}
      >
        <Col
          onClick={event => event.preventDefault()}
          md={1}
          sm={1}
          xs={1}
          style={{
            top: isMobile ? '-15px' : '',
            paddingLeft: isMobile ? '10px' : '15px',
            paddingRight: isMobile ? '0px' : '10px',
          }}
        >
          <PreferredStar handleFavourites={handleFavourites} isSelected={matchRow.get('favourite')} />
        </Col>
        {isMobile &&
          <Col sm={5.7} xs={5.7} style={{ paddingRight: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['homeTeam', 'teamName'])}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('homeTeam'))}
              marginLeft={0.4}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'home'}
            />
            <TeamLabel
              label={matchRow.getIn(['awayTeam', 'teamName'])}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('awayTeam'))}
              marginLeft={0.4}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'away'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['homeTeam', 'teamName'])}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('homeTeam'))}
              marginLeft={0.5}
              font={isHomeWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'home'}
            />
          </Col>
        }
        {!isMobile &&
          <Col md={3} style={{ paddingLeft: 0, paddingRight: 0 }}>
            <TeamLabel
              label={matchRow.getIn(['awayTeam', 'teamName'])}
              color="black"
              image={getFootballTeamImagePath(imagesURL, matchRow.get('awayTeam'))}
              marginLeft={0.5}
              font={isAwayWinner() ? 'narrowMedium' : 'narrowRegular'}
              isLoserCrossed={getRoundTripLoser() === 'away'}
            />
          </Col>
        }
        <Col md={2} sm={2} xs={2} style={{ paddingRight: 0, paddingLeft: isMobile ? '0px' : '15px' }}>
          <Timing
            isMobile={isMobile}
            timing={matchRow.get('timing')}
            resultType={matchRow.get('resultType')}
            date={matchRow.get('utcDate')}
            isLive={isLive()}
            dictionary={dictionary}
            actions={actions}
          />
        </Col>
        <Col lg={2} md={1.5} sm={1.5} xs={1.5} style={{ paddingLeft: 0, paddingRight: isMobile ? '0px' : '15px' }}>
          <Result
            awayRes={matchRow.getIn(['awayTeam', 'score'])}
            awayPenRes={awayResPen}
            homePenRes={homeResPen}
            homeRes={matchRow.getIn(['homeTeam', 'score'])}
            status={matchRow.get('status')}
            isMobile={isMobile}
          />
        </Col>
        <Col
          lg={1}
          md={1.8}
          sm={1.8}
          xs={1.5}
          style={{
            display: 'flex', justifyContent: 'flex-end', flexDirection: 'row', paddingRight: isMobile ? '10px' : '10px', paddingLeft: isMobile ? '0' : '15px',
          }}
        >
          <IconFont
            className="icon-matchcenter-right-arrow"
            color="selectedColor"
            font={18}
            weight="bold"
            withCursor
          />
          {/* matchRow.get('status') === status.FULL_STATUS || (date === 'yesterday') || isDeskFav ?
            <IconFont
              className="icon-matchcenter-right-arrow"
              color="selectedColor"
              font={18}
              weight="bold"
              withCursor
            />
            :
            <a
              href={`/test/matchcenter/Calcio/${dictionary.competitionLink[Number(competitionId)]}/partite/${prettyHomeTeam}-${prettyAwayTeam}/${matchRow.get('matchId')}/quote`}
            >
              <IconFont
                className="icon-matchcenter-bet"
                font={28}
                style={{ display: 'inline-block' }}
                withCursor
              >
                <span className="path1" />
                <span className="path2" />
                <span className="path3" />
                <span className="path4" />
              </IconFont>
            </a>
           */}
        </Col>
      </Row>
      {showRowScorer && matchRow && matchRow.get('status') !== 'WALKOVER' &&(
        matchRow.getIn(['homeTeam', 'starData', 'goals']).size > 0 || matchRow.getIn(['starData', 'substitutions']) > 0
        || matchRow.getIn(['starData', 'yellowBookings']) > 0 || matchRow.getIn(['starData', 'redBookings']) > 0 ||
        matchRow.getIn(['awayTeam', 'starData', 'goals']).size > 0) &&
        <Row style={{
          width: '100%', marginRight: '0', marginLeft: '0', alignItems: 'initial',
        }}
        >
          <Col md={3} sm={3} xs={3} offset={{ md: 1, sm: 1, xs: 1 }} style={{ paddingRight: '0px', paddingLeft: '34px' }}>
            <MatchRowScorers
              color="gray"
              weight="normal"
              size={0.8}
              scorers={matchRow.getIn(['homeTeam', 'starData', 'goals'])}
              font="narrowRegular"
            />
            {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['homeTeam', 'starData', 'shootOuts']) && matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties']) &&
            <MatchRowScorers
              color="gray"
              weight="normal"
              size={1.5}
              penaltyScorers={matchRow.getIn(['homeTeam', 'starData', 'shootOuts', 'penalties'])}
              font="narrowRegular"
            />
            }
          </Col>
          <Col md={3} sm={3} xs={3} style={{ paddingRight: '0px', paddingLeft: '34px' }}>
            <MatchRowScorers
              color="gray"
              weight="normal"
              size={0.8}
              scorers={matchRow.getIn(['awayTeam', 'starData', 'goals'])}
              font="narrowRegular"
            />
            {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['awayTeam', 'starData', 'shootOuts']) && matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties']) &&
            <MatchRowScorers
              color="gray"
              weight="normal"
              size={1.5}
              penaltyScorers={matchRow.getIn(['awayTeam', 'starData', 'shootOuts', 'penalties'])}
              font="narrowRegular"
            />
            }
          </Col>
          <Col xl={3.6} lg={3.4} md={3} sm={3} xs={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline' }} offset={{ md: 1, sm: 1, xs: 1 }}>
            <MatchStatsWrapper>
              {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'substitutions']) > 0 &&
                <MatchRowIcon
                  matchStats={matchRow.getIn(['starData', 'substitutions'])}
                  color="black"
                  bg="green"
                  size={12}
                  className="icon-matchcenter-arrows-circle"
                  marginRight={0.2}
                  font="narrowMedium"
                  isSubstitution
                />
              }
              {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'redBookings']) > 0 &&
                <MatchRowIcon
                  matchStats={matchRow.getIn(['starData', 'redBookings'])}
                  color="white"
                  bg="red"
                  size={12}
                  className="icon-matchcenter-rectangle"
                  font="narrowMedium"
                />
              }
              {matchRow && matchRow.get('status') !== 'WALKOVER' && matchRow.getIn(['starData', 'yellowBookings']) > 0 &&
                <MatchRowIcon
                  matchStats={matchRow.getIn(['starData', 'yellowBookings'])}
                  color="black"
                  bg="yellow"
                  size={12}
                  className="icon-matchcenter-rectangle"
                  font="narrowMedium"
                />
              }
              {matchRow.get('status') === 'WALKOVER' &&
                <MatchForfait>
                  {`${dictionary.competitionTable.timing.Walkover}`}
                </MatchForfait>
              }
            </MatchStatsWrapper>
          </Col>
        </Row>
      }
      {/* (matchRow.get('status') !== status.FULL_STATUS || (date !== 'yesterday')) && isDeskFav &&
        <BetBar />
       */}
    </MatchRowWrapper>
  );
};

MatchRow.propTypes = {
  matchRow: PropTypes.any,
  showRowScorer: PropTypes.any,
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  isMobile: PropTypes.bool,
  date: PropTypes.string,
  sportId: PropTypes.any,
  isHighlight: PropTypes.bool,
  competitionId: PropTypes.any,
};

export default MatchRow;
